/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'company-hub.spotlight-extension.config-panel.preamble':
    'Fremhæv vigtige budskaber med et visuelt spotlight. {supportLink}',
  'company-hub.spotlight-extension.config-panel.preamble-link.label': 'Få mere at vide om spotlights',
  'company-hub.spotlight-extension.config-panel.preamble-without-support-link':
    'Fremhæv vigtige budskaber med et visuelt spotlight.',
  'company-hub.spotlight-extension.config-panel.title': 'Spotlight',
  'company-hub.spotlight-extension.hub-element.description': 'Fremhæv vigtige meddelelser',
  'company-hub.spotlight-extension.hub-element.title': 'Spotlight',
  'company-hub.spotlight-extension.manifest.initial-state.alt-image-text': 'Landskabsfotografering af ørken',
  'company-hub.spotlight-extension.manifest.initial-state.text-description':
    'Design et spotlight for at fremhæve dine allervigtigste oplysninger. Væk de allervigtigste budskaber til live med brugerdefinerede farver, et stærkt billede og fleksible layouts.',
  'company-hub.spotlight-extension.manifest.initial-state.text-title': 'Giv dit spotlight en titel',
  'company-hub.spotlight-extension.manifest.macro-description': 'Fremhæv vigtige budskaber med et visuelt spotlight.',
  'company-hub.spotlight-extension.manifest.macro-title': 'Spotlight',
  'company-hub.spotlight-extension.manifest.macro-title.new': 'Spotlight [Ny]',
  'company-hub.spotlight-extension.spotlight-config-panel.content-tab.label': 'Indhold',
  'company-hub.spotlight-extension.spotlight-config-panel.general-title': 'Generelt',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts-title': 'Layout',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.description':
    'Tekstfeltoverlejring på et stort billede',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.label':
    'Indholdsramme inde i billedet',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.description':
    'Billede i fuld størrelse bag dit indhold',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.label': 'Billedbaggrund',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.description':
    'Indhold foran en farve i fuld bredde',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.label': 'Ensfarvet baggrund',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.description':
    'Stort billede til højre med masser af plads til indhold',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.label':
    'Opdelt design (indhold først)',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.description':
    'Stort billede til venstre med masser af plads til indhold',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.label':
    'Opdelt design (billede først)',
  'company-hub.spotlight-extension.spotlight-config-panel.styles-tab.label': 'Stile',
  'company-hub.spotlight-extension.spotlight-config-panel.text-description-label': 'Beskrivelse',
  'company-hub.spotlight-extension.spotlight-config-panel.text-description-placeholder':
    'Spotlights fremhæver vigtige meddelelser til dit team. Design dit spotlight med et billede, dine brugerdefinerede farver, en kort beskrivelse og et link.',
  'company-hub.spotlight-extension.spotlight-config-panel.text-image-label': 'Billede',
  'company-hub.spotlight-extension.spotlight-config-panel.text-title-label': 'Titel',
  'company-hub.spotlight-extension.spotlight-config-panel.text-title-placeholder': 'Giv dit spotlight en titel',
  'company-hub.spotlight-extension.spotlight.background.color': 'Baggrundsfarve',
  'company-hub.spotlight-extension.spotlight.color-contrast.fail':
    'Dine valgte farver til tekst og baggrund er ikke gode i forhold til læsbarhed.',
  'company-hub.spotlight-extension.spotlight.color-contrast.success':
    'Dine valgte farver til tekst og baggrund er gode i forhold til læsbarhed.',
  'company-hub.spotlight-extension.spotlight.text.color': 'Tekstfarve',
};
